import "./LoginLoader.css";
import { LoginLoaderBody } from "./components/LoginLoaderBody";
export const LoginLoader = () => {
  return (
    <div className="login-loader-page-wrapper">
      <LoginLoaderBody />
    </div>
  );
};
